import { render, staticRenderFns } from "./FactorEditForm.vue?vue&type=template&id=fa118ef4"
import script from "./FactorEditForm.vue?vue&type=script&lang=js"
export * from "./FactorEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports